import * as React from 'react';
type IconHomeProps = React.SVGProps<SVGSVGElement>;

export const IconHome: React.FC<IconHomeProps> = (props) => (
	<svg
	width={20} height={20} viewBox="0 0 20 20"  xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M10.6822 2.26865C10.2978 1.9124 9.70407 1.9124 9.32282 2.26865L2.32282 8.76865C2.02282 9.0499 1.92282 9.48428 2.07282 9.86553C2.22282 10.2468 2.58845 10.4999 3.00095 10.4999H3.50095V15.9999C3.50095 17.103 4.39782 17.9999 5.50095 17.9999H14.5009C15.6041 17.9999 16.5009 17.103 16.5009 15.9999V10.4999H17.0009C17.4134 10.4999 17.7822 10.2468 17.9322 9.86553C18.0822 9.48428 17.9822 9.04678 17.6822 8.76865L10.6822 2.26865ZM9.50095 11.9999H10.5009C11.3291 11.9999 12.0009 12.6718 12.0009 13.4999V16.4999H8.00095V13.4999C8.00095 12.6718 8.67282 11.9999 9.50095 11.9999Z" />
</svg>


);
export default IconHome;
